export const FauxFurPomPomFaqSeo = {
    title: "Handmade Faux Fur Pom Poms FAQ | Wholesale & Custom Colors – Arte Craft India",
    description: "Complete FAQ for handmade faux fur pom poms. Learn about materials, sizes, colors, custom orders, wholesale MOQ, and shipping. Cruelty-free manufacturer supplying 50+ countries.",
    keywords: "faux fur pom poms, handmade faux fur pompoms, faux fur hat pompom, wholesale faux fur pom poms, custom faux fur pom poms, buy faux fur pom poms, faux fur pompom manufacturer, pom poms for hats, fluffy pom poms, faux fur ball",
    canonical: "https://www.artecraftindia.com/faux-fur-pom-poms-faq",
    author: "Arte Craft India",
    robots: "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
    ogType: "website",
    ogUrl: "https://www.artecraftindia.com/faux-fur-pom-poms-faq",
    ogSiteName: "Arte Craft India",
    ogImage: "https://www.artecraftindia.com/images/faux-fur-pom-poms-faq-og.jpg",
    ogImageAlt: "Handmade faux fur pom poms in multiple colors arranged on a surface",
    ogLocale: "en_US",
    twitterCard: "summary_large_image" as const,
    twitterImage: "https://www.artecraftindia.com/images/faux-fur-pom-poms-faq-twitter.jpg",
};
